import type { ScanResult } from "../contexts/ScannerContext";

/**
 * What the Returns list's "Scan or type" box sends to the lookup. Wilma's own tags encode
 * "p|{partId}|{tagNumber}"; a courier label is just its tracking number, and a typed value is
 * passed through as typed.
 */

/** The tag number from a part tag, else the raw value (a tracking number or typed text). */
export function lookupValueFromScan({ raw, parts }: ScanResult): string {
  if (parts.length >= 3 && parts[0].toLowerCase() === "p" && parts[2]) return parts[2].trim();
  return raw.trim();
}

/** Turns typed text into the same shape a physical scan arrives in. */
export function scanFromText(text: string): ScanResult {
  const raw = text.trim();
  return { raw, parts: raw.split(/[|~]/) };
}
